import Vue from 'vue';
import Vuex from 'vuex';

const fb = require('../firebaseConfig.js')

Vue.use(Vuex)

// handle page reload
/*fb.auth.onAuthStateChanged(user => {
	if (user) {
		store.commit('setCurrentUser', user)
		store.dispatch('fetchUserProfile')

		fb.usersCollection.doc(user.uid).onSnapshot(doc => {
			store.commit('setUserProfile', doc.data())
		})

		// realtime updates from our posts collection
		fb.postsCollection.orderBy('createdOn', 'desc').onSnapshot(querySnapshot => {
			// check if created by currentUser
			let createdByCurrentUser
			if (querySnapshot.docs.length) {
				createdByCurrentUser = store.state.currentUser.uid == querySnapshot.docChanges[0].doc.data().userId ? true : false
			}

			// add new posts to hiddenPosts array after initial load
			if (querySnapshot.docChanges.length !== querySnapshot.docs.length
				&& querySnapshot.docChanges[0].type == 'added' && !createdByCurrentUser) {

				let post = querySnapshot.docChanges[0].doc.data()
				post.id = querySnapshot.docChanges[0].doc.id

				store.commit('setHiddenPosts', post)
			} else {
				let postsArray = []

				querySnapshot.forEach(doc => {
					let post = doc.data()
					post.id = doc.id
					postsArray.push(post)
				})

				store.commit('setPosts', postsArray)
			}
		})
	}
})*/

export default new Vuex.Store({
	state: {
		currentUser: null,
		userProfile: {},
		commentsModalActive : false,
		comments : {list : [], status : 'Loading comments...'},
		currentMovie : {id : null, type : null}
	},
	mutations: {
		setCurrentUser(state, val) {
			state.currentUser = val
		},
		setUserProfile(state, val) {
			state.userProfile = val
		},
		setCommentsModalActiveStatus(state, val){
			state.commentsModalActive = val;
		},
		populateComments(state, payload){
			Vue.set(state, 'comments', payload);
		},
		setCurrentMovie(state, payload){
			Vue.set(state, 'currentMovie', payload);
		},
	},
	getters : {

	},
	actions: {
		clearData({commit}) {
			commit('setCurrentUser', null);
			commit('setUserProfile', {});
		},
		/*fetchUserProfile({ commit, state }) {
			fb.usersCollection.doc(state.currentUser.uid).get().then(res => {
				commit('setUserProfile', res.data());
			}).catch(err => {
				console.log(err)
			})
		},*/
		fetchUser({ commit }, user) {
			commit("setCurrentUser", user);
			// this.dispatch('fetchUserProfile');
		},
		activateCommentsModal(context) {
			context.commit('setCommentsModalActiveStatus', true);
		},
		deactivateCommentsModal(context) {
			context.commit('setCommentsModalActiveStatus', false);
		},
		resetComments(context) {
			context.commit('populateComments', {list : [], status : 'Loading comments...'});
		},
		fetchMovieComments(context, payload) {
			let id = parseInt(payload['id']);
			let commentsList = [];
			let commentsQuery = fb.commentCollection.where('movieId', '==', id).orderBy('createdOn', 'desc').limit(21);
			commentsQuery.get()
			.then((docs) => {
				docs.forEach((doc) => {
					let comment = doc.data();
					comment['id'] = doc['id'];
					commentsList.push(comment);
				});
				let mutationPayload = {list : commentsList, status : 'Be the first one to comment'};
				if (commentsList.length > 0) {
					mutationPayload['status'] = 'Comments found'
				}
				context.commit('populateComments', mutationPayload);
			})
			.catch((err) => {
				console.error(err.message);
			})
		},
		updateCurrentMovie(context, payload) {
			let id = parseInt(payload['id']);
			let mutationPayload = Object.assign(payload, {id : id});
			context.commit('setCurrentMovie', mutationPayload);
		},
	},
	modules: {
	},
});
